import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { Popup } from "semantic-ui-react";

import { useConciliationRatio } from "src/containers/conciliationRatio";
import { HMRModal } from "src/containers/HistoricalMonthlyReconciliations/HMRModal";
import { getProgressTier } from "src/utils/reconciliationProgress";

const SIZE = 36;
const STROKE = 3.5;
const RADIUS = (SIZE - STROKE) / 2;
const CIRCUMFERENCE = 2 * Math.PI * RADIUS;

const ConciliationRatioCircle = () => {
  const { t } = useTranslation("header");
  const { ratioPct } = useConciliationRatio();
  const [openHRMModal, setOpenHRMModal] = useState(false);

  const displayPercent = parseFloat(ratioPct || 0).toFixed(1);
  const roundedPercent = Math.round(ratioPct);
  const tier = getProgressTier(ratioPct);
  const dashOffset = CIRCUMFERENCE * (1 - ratioPct / 100);
  const tooltip = t("reconciliation.reconciledThisMonth", {
    percent: displayPercent,
  });

  return (
    <div className="conciliationRatioCircleWrap">
      <Popup
        inverted
        size="mini"
        position="bottom center"
        className="conciliationRatioCircleTooltip"
        content={tooltip}
        mouseEnterDelay={180}
        trigger={
          <button
            type="button"
            className={`conciliationRatioCircle conciliationRatioCircle--${tier}`}
            onClick={() => setOpenHRMModal(true)}
            aria-label={tooltip}
          >
            <svg
              className="conciliationRatioCircle__svg"
              width={SIZE}
              height={SIZE}
              viewBox={`0 0 ${SIZE} ${SIZE}`}
              aria-hidden="true"
            >
              <circle
                className="conciliationRatioCircle__track"
                cx={SIZE / 2}
                cy={SIZE / 2}
                r={RADIUS}
                fill="none"
                strokeWidth={STROKE}
              />
              <circle
                className="conciliationRatioCircle__fill"
                cx={SIZE / 2}
                cy={SIZE / 2}
                r={RADIUS}
                fill="none"
                strokeWidth={STROKE}
                strokeLinecap="round"
                strokeDasharray={CIRCUMFERENCE}
                strokeDashoffset={dashOffset}
                transform={`rotate(-90 ${SIZE / 2} ${SIZE / 2})`}
              />
            </svg>
            <span
              className={`conciliationRatioCircle__value${
                roundedPercent >= 100 ? " conciliationRatioCircle__value--full" : ""
              }`}
            >
              {roundedPercent}
              <span className="conciliationRatioCircle__percent">%</span>
            </span>
          </button>
        }
      />
      <HMRModal open={openHRMModal} setOpen={setOpenHRMModal} />
    </div>
  );
};

export default ConciliationRatioCircle;
